import type { PageRegistry } from "./pageTypes";
import type { LegacyPageConfig } from "./legacyPageRegistryTypes";

/**
 * Helpers para trabalhar com o pageRegistry do legado.
 *
 * Mantém a API semelhante ao `src-next/shared/routing/pageRegistryHelpers.ts`.
 */
export function createLegacyPageRegistryHelpers(registry: PageRegistry<LegacyPageConfig>) {
  const getPageConfig = (pageName: string | undefined): LegacyPageConfig | undefined => {
    if (!pageName) {
      return undefined;
    }

    return registry[pageName];
  };

  const isPageRegistered = (pageName: string): boolean => {
    return pageName in registry;
  };

  const getAvailablePages = (): string[] => {
    return Object.keys(registry);
  };

  return {
    registry,
    getPageConfig,
    isPageRegistered,
    getAvailablePages,
  };
}

